export default {
  GOOD: 1,
  NORMAL: 2,
  BAD: 3,
};
